/**
 * Device Model Navigation
 * Handles dropdown open/close interactions
 */

(function() {
  'use strict';

  class DeviceModelNav {
    constructor(container) {
      this.container = container;
      this.button = container.querySelector('[data-device-model-nav-button]');
      this.dropdown = container.querySelector('[data-device-model-nav-dropdown]');

      if (!this.button || !this.dropdown) {
        return;
      }

      this.container.dataset.deviceModelNavInitialized = 'true';
      this.isOpen = false;
      this.init();
    }

    init() {
      // Button click handler
      this.button.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.toggle();
      });

      // Close on outside click
      document.addEventListener('click', (e) => {
        if (this.isOpen && !this.container.contains(e.target)) {
          this.close();
        }
      });

      // Close on Escape key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen) {
          this.close();
          this.button.focus();
        }
      });

      // Trap focus within dropdown when open
      this.dropdown.addEventListener('keydown', (e) => {
        if (e.key === 'Tab') {
          this.handleTabKey(e);
        }
      });
    }

    toggle() {
      if (this.isOpen) {
        this.close();
      } else {
        this.open();
      }
    }

    open() {
      this.isOpen = true;
      this.button.classList.add('is-active');
      this.button.setAttribute('aria-expanded', 'true');
      this.dropdown.hidden = false;

      // Don't auto-focus first link to avoid triggering hover state
      // Users can navigate with Tab key if needed
    }

    close() {
      this.isOpen = false;
      this.button.classList.remove('is-active');
      this.button.setAttribute('aria-expanded', 'false');
      this.dropdown.hidden = true;
    }

    handleTabKey(e) {
      const focusableElements = this.dropdown.querySelectorAll(
        'a[href], button:not([disabled])'
      );
      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];

      if (e.shiftKey) {
        // Shift + Tab
        if (document.activeElement === firstElement) {
          e.preventDefault();
          this.button.focus();
        }
      } else {
        // Tab
        if (document.activeElement === lastElement) {
          e.preventDefault();
          this.close();
          this.button.focus();
        }
      }
    }
  }

  function mountHeaderDeviceNavInSectionDrawer() {
    const sectionDrawer = document.querySelector('mobile-menu[data-drawer-section]');
    const headerDrawer = document.querySelector('mobile-menu[data-drawer-header]');

    if (!sectionDrawer || !headerDrawer) {
      return;
    }

    const slot = sectionDrawer.querySelector('[data-device-model-nav-mobile-slot]');
    const deviceNavItem = headerDrawer.querySelector('.mobile-menu__item--device-nav');

    if (!slot || !deviceNavItem) {
      return;
    }

    if (deviceNavItem.parentElement !== slot) {
      slot.prepend(deviceNavItem);
    }
  }

  // Initialize all device model nav instances
  function initDeviceModelNav() {
    mountHeaderDeviceNavInSectionDrawer();
    const containers = document.querySelectorAll('[data-device-model-nav]');
    containers.forEach(container => {
      if (container.dataset.deviceModelNavInitialized === 'true') {
        return;
      }
      new DeviceModelNav(container);
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDeviceModelNav);
  } else {
    initDeviceModelNav();
  }

  // Re-initialize on Shopify section load (for theme editor)
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', initDeviceModelNav);
  }

  // Mobile drawer collapsible functionality
  function initMobileDeviceNav() {
    const wrappers = document.querySelectorAll('[data-device-nav-mobile]');

    wrappers.forEach(wrapper => {
      if (wrapper.dataset.deviceNavMobileInitialized === 'true') {
        return;
      }

      const button = wrapper.querySelector('[data-device-nav-mobile-button]');
      const dropdown = wrapper.querySelector('[data-device-nav-mobile-dropdown]');

      if (!button || !dropdown) {
        return;
      }

      wrapper.dataset.deviceNavMobileInitialized = 'true';

      button.addEventListener('click', function(e) {
        e.preventDefault();
        const isExpanded = this.getAttribute('aria-expanded') === 'true';

        // Toggle aria-expanded
        this.setAttribute('aria-expanded', !isExpanded);

        // Toggle dropdown visibility
        if (!isExpanded) {
          dropdown.hidden = false;
        } else {
          dropdown.hidden = true;
        }
      });
    });
  }

  // Initialize mobile nav
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileDeviceNav);
  } else {
    initMobileDeviceNav();
  }

  // Re-initialize on Shopify section load (for theme editor)
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', initMobileDeviceNav);
  }
})();
